import { post } from '@va/http-client';

export const signUpPromoter = (websiteId, refId) => {
  const url = `/websites/${websiteId}/fp/track/signup`;

  return post(url, {}, { _fprom_code: refId });
};
